import { actionTypes } from "./auth.constant";

export const onLoginLoading = () => {
  return {
    type: actionTypes.ON_LOGIN_LOADING,
  };
};
export const onLoginSuccess = () => {
  return {
    type: actionTypes.ON_LOGIN_SUCCESS,
  };
};
export const onLoginErr = (payload) => {
  return {
    type: actionTypes.ON_LOGIN_ERR,
    payload: payload,
  };
};

export const onLogout = () => {
  return {
    type: actionTypes.ON_LOGIN_LOADING,
  };
};
